import _ from 'lodash';
import React from 'react';
import { Icon, Label } from 'semantic-ui-react';
import { appIconTypes } from '../../../enums/appIconTypes';

const TableMap = (props) => {

  const { tmProps } = props
  const { fip, itemProp, data_init: cd, swipedItem, swipeToSelected } = tmProps

  const si = { ...swipedItem }
  si.itemProp = itemProp
  si.fip = fip
  si.dataId = cd.id
  si.breadCaption = cd.name
  const swipeProps = { swipedItem: si, menuType: 'viewItemData' }
  return <Label className={'table-label'} onClick={(e) => swipeToSelected(swipeProps)}>
    <Icon name={appIconTypes.arrowRight} />
    {_.startCase(itemProp.key) + ' {...}'}
  </Label>
}

export default TableMap